__webpack_require__.p = "/image-detect/";